module.exports = __webpack_public_path__ + "img/20_newModelWorker_zgy.d83854da.png";